import { isPublicAgencyId } from './agencyUrl';

const ACTIONS = new Set(['call', 'email', 'info', 'reviews', 'view']);
const SOURCES = new Set(['results', 'favorites', 'agency_detail', 'contacts']);

function endpoint() {
    const base = process.env.REACT_APP_AUTH_API_URL?.trim();
    return base ? `${base.replace(/\/+$/, '')}/interactions` : null;
}

// Keep this request independent of navigation and of the authentication session.
// The server keeps daily aggregate counters. A random, single-event ID only
// prevents a retry counting twice; it never identifies a visitor or session.
export async function trackInteraction({ action, agencyId, source, targetType = 'agency' }) {
    // The owner's private profile is a preview, not a visitor interaction.
    if (source === 'profile') return false;
    try {
        const url = endpoint();
        if (!url || !ACTIONS.has(action) || !SOURCES.has(source) || !['agency', 'platform'].includes(targetType)) return false;
        if (targetType === 'agency' && !isPublicAgencyId(agencyId)) return false;

        const eventId = typeof window.crypto?.randomUUID === 'function'
            ? window.crypto.randomUUID()
            : Array.from(window.crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
        const request = {
            method: 'POST',
            // JSON encoded as text avoids a CORS preflight when opening tel:/mailto:.
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            credentials: 'omit',
            referrerPolicy: 'no-referrer',
            cache: 'no-store',
            keepalive: true,
            body: JSON.stringify({
                schemaVersion: 1,
                eventId,
                action,
                targetType,
                agencyId: targetType === 'agency' ? String(agencyId) : null,
                source,
                occurredAt: new Date().toISOString(),
            }),
        };
        // One bounded retry lives only in this call's memory. No browser
        // storage, cookie or persistent offline queue is used.
        for (let attempt = 0; attempt < 2; attempt += 1) {
            try {
                const response = await fetch(url, request);
                if (response.ok) return true;
                if (response.status < 500 || attempt === 1) return false;
            } catch {
                if (attempt === 1) return false;
            }
        }
        return false;
    } catch {
        // A failed counter must never prevent the visitor from contacting an agency.
        return false;
    }
}
